/**
 * Sorts an array of objects alphabetically by the given key.
 * Case-insensitive and returns a new sorted array (does not mutate original).
 *
 * @param data - The array to sort
 * @param key - The object key to sort by (e.g., "name")
 * @returns A new sorted array
 */
export const sortByKey = <T extends Record<string, any>>(data: T[] | undefined, key: keyof T): T[] => {
  if (!Array.isArray(data)) return [];
  return [...data].sort((a, b) => {
    const aValue = String(a[key] ?? "").toLowerCase();
    const bValue = String(b[key] ?? "").toLowerCase();
    return aValue.localeCompare(bValue);
  });
};
